import { ScaniaUnit, ComponentType } from 'src/state';

export interface ScaniaUnitComponentType {
    id: number;
    componentTypeId: string;
    scaniaUnitId: boolean;
    componentType: ComponentType;
    scaniaUnit : ScaniaUnit
}
